import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import {
  ILayout,
  configureLayoutQuery,
  DashboardComponentNames,
  IDashboardComponentProperties,
  usePerformanceReportBuilderPageStore,
  layoutQuery,
} from '@diana/core';

type TResult = ILayout<IDashboardComponentProperties, DashboardComponentNames>;

export const useGetOrCreateDraftLayoutMutation = (
  options?: UseMutationOptions<TResult, unknown, string>,
): UseMutationResult<TResult, unknown, string> => {
  const setLayout = usePerformanceReportBuilderPageStore((s) => s.setLayout);
  const setDefaultQuickFilterProperty = usePerformanceReportBuilderPageStore(
    (s) => s.setDefaultQuickFilterProperty,
  );

  return useMutation({
    mutationFn: async (layoutId) => {
      const [reports, draftLayout] = await Promise.all([
        layoutQuery.getPerformanceReports().fn(),
        configureLayoutQuery.getOrCreateDraft({ layoutId }).fn({}),
      ]);

      const publishedLayout = reports.find(
        (r) =>
          r.id === draftLayout.originId ||
          r.originId === draftLayout.originId ||
          r.draftId === draftLayout.id,
      );

      setLayout(draftLayout);
      setDefaultQuickFilterProperty(publishedLayout?.quickFilterProperty ?? { keys: {} });
      return draftLayout;
    },
    ...options,
  });
};
